import { render, staticRenderFns } from "./EbillDetailsCard.vue?vue&type=template&id=4a71a869"
import script from "./EbillDetailsCard.vue?vue&type=script&lang=js"
export * from "./EbillDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./EbillDetailsCard.vue?vue&type=style&index=0&id=4a71a869&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports